import { ObjectMapper } from "json-object-mapper";
import { IModel } from "../IModel";
import { Model } from "../model";

export class ProbationaryPeriodModel extends Model implements IModel<ProbationaryPeriodModel>
{
  static create(input: any): ProbationaryPeriodModel {
    return ObjectMapper.deserialize<ProbationaryPeriodModel>(ProbationaryPeriodModel, input);
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}
